module.exports = __webpack_public_path__ + "img/edc-permata.1bcc81ef.png";